import PropTypes from "prop-types";
import React from "react";
import { handleScrollTop } from "shared/helpers/scrollTo";
import { get } from "lodash";
import { Link } from "react-router";
import { FormattedMessage } from "react-intl";
import { Menu, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { getPageMenu } from "shared/selectors/pageMenu";

import logoutAction from "buyer_portal/actions/logoutAction";

import "./pageMenu.scss";

function PageMenu(props) {
  const { menu } = props;

  function handleClick() {
    const { sidebarIsVisible, onToggleSidebar } = props;

    if (sidebarIsVisible) {
      onToggleSidebar(false);
    }

    handleScrollTop();
  }

  const renderLink = item => {
    if (item.id === "units") {
      const { UnitsMenuItemText } = props;
      return (
        <Link onlyActiveOnIndex to={item.link}>
          <div>
            {item.icon ? <Icon name={item.icon.name} /> : null}
            {UnitsMenuItemText.length ? (
              UnitsMenuItemText
            ) : (
              <FormattedMessage
                id={item.message}
                defaultMessage="Meine Wohnungen"
              />
            )}
          </div>
        </Link>
      );
    }
    if (item.link) {
      return (
        <Link onlyActiveOnIndex to={item.link}>
          <div>
            {item.icon ? <Icon name={item.icon.name} /> : null}
            {item.message && (
              <FormattedMessage
                id={item.message}
                defaultMessage={item.message}
              />
            )}
          </div>
        </Link>
      );
    }
    if (item.action) {
      const { actions } = props;
      return (
        <a href="#" onClick={actions[item.action]}>
          {item.icon ? <Icon name={item.icon.name} /> : null}
          {item.message && (
            <FormattedMessage id={item.message} defaultMessage={item.message} />
          )}
        </a>
      );
    }
    return null;
  };

  const menuItems = menu.map(item => {
    return (
      <Menu.Item
        as="div"
        key={item.id}
        name={item.id}
        onClick={handleClick}
        className={item.id}
      >
        {renderLink(item)}
      </Menu.Item>
    );
  });

  return (
    <Menu.Menu data-component="pageMenu" position="right">
      {menuItems}
    </Menu.Menu>
  );
}

PageMenu.propTypes = {
  menu: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  sidebarIsVisible: PropTypes.bool.isRequired,
  onToggleSidebar: PropTypes.func.isRequired,
  UnitsMenuItemText: PropTypes.string
};

PageMenu.defaultProps = {
  UnitsMenuItemText: ""
};

const mapStateToProps = (state, props) => {
  const branding = get(state.branding, props.projectId);
  const UnitsMenuItemText = get(branding, "units_menu_item_text");
  return {
    menu: getPageMenu(state),
    UnitsMenuItemText
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    logoutAction: logoutAction(dispatch)
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PageMenu);
